import { render, staticRenderFns } from "./editor-controls.vue?vue&type=template&id=b3eb5aaa&scoped=true&"
import script from "./editor-controls.vue?vue&type=script&lang=ts&"
export * from "./editor-controls.vue?vue&type=script&lang=ts&"
import style0 from "./editor-controls.vue?vue&type=style&index=0&id=b3eb5aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3eb5aaa",
  null
  
)

export default component.exports